import { useEffect, useState } from 'react'

import { visitorCountry } from '@/components/client/site-popups/visitor-country'

export const useGuideEligibility = () => {
  const [eligible, setEligible] = useState(false)

  useEffect(() => {
    if (visitorCountry() !== 'US') {
      return
    }

    const controller = new AbortController()
    const verifyVisitor = async () => {
      try {
        const response = await fetch('/api/hearing-aids/guide-eligibility', {
          method: 'POST',
          cache: 'no-store',
          signal: controller.signal,
        })
        if (!response.ok) {
          return
        }
        const result: { eligible?: boolean } | null = await response.json()
        if (!controller.signal.aborted && result?.eligible === true) {
          setEligible(true)
        }
      } catch {
        // Missing or failed verification keeps the entire guide unmounted.
      }
    }

    void verifyVisitor()
    return () => controller.abort()
  }, [])

  return eligible
}
